import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../auth.service";
import { FormBuilder, FormGroup } from "@angular/forms";

@Injectable()
export class MaintenanceService {
    router: Router;
    private readonly formBuilder: FormBuilder;
    editForm: FormGroup;

    constructor(
        private readonly injector: Injector,
        private readonly authService: AuthenticationService,
        
        ) {
        this.router = this.injector.get(Router);
        this.authService = this.injector.get(AuthenticationService);
        this.formBuilder = this.injector.get(FormBuilder);

        this.editForm = this.formBuilder.group(selectionEditForm);
    }

    getCurrentPageValue() {
        const splits = this.router.url.split('/');
        const selectedValue = splits[splits.length - 1];
        this.editForm.get('selectedValue').setValue(selectedValue);
    }

    dropdownSelectionChange(selected: any): void {
        this.router.navigate([`MESC/Administration/Maintenance/${selected.value}`]);
    }

    getDropDown(): any[] {
        return [
            {
                text: 'Plants',
                value: 'Plants'
            },
            {
                text: 'Programs',
                value: 'Programs'
            },
            {
                text: 'Plant-Program',
                value: 'Plant-Program'
            },
            {
                text: 'Program Style',
                value: 'Program-Style'
            },
            {
                text: 'SubZone',
                value: 'SubZone'
            },
            {
                text: 'Title',
                value: 'Title'
            },
            {
                text: 'ZoneSubZoneTitle',
                value: 'ZoneSubZoneTitle'
            },
            {
                text: 'Model Year',
                value: 'Model-Year'
            }
        ];
    }
}

const selectionEditForm = {
    selectedValue: [],
};